import { render, staticRenderFns } from "./InputMealCategory.vue?vue&type=template&id=9f7a8514"
import script from "./InputMealCategory.vue?vue&type=script&lang=js"
export * from "./InputMealCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports